module.exports = __webpack_public_path__ + "static/media/play_small.36da2628.svg";